import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BackHandIcon(props: IconProps) {
    return <Icon {...props} iconKey={"back_hand"}/>
}
